export default __webpack_public_path__ + "static/media/ar_2013_image.7ac2e141.jpg";